import Persistable from "../../storage/persistable";
import IncompleteType from "./enums/incomplete-type";

export default class Match extends Persistable {
    constructor(
        match = {
            matchNumber: undefined,
            isShortened: false,
            away: {
                players: [],
                teamId: undefined,
                rank: undefined,
                incompleteType: undefined
            },
            home: {
                players: [],
                teamId: undefined,
                rank: undefined,
                incompleteType: undefined
            },
            sets: [],
            tiebreakSets: [],
            matchTiebreakType: undefined,
            eventId: undefined,
            isSingle: undefined,
            duration: undefined
        }
    ) {
        super();

        Object.assign(this, match);
    }

    bothTeamsDisqualified() {
        const awayCode = this.away.incompleteType;
        const homeCode = this.home.incompleteType;
        return (
            (IncompleteType.DQ.equals(awayCode) &&
                IncompleteType.DQ.equals(homeCode)) ||
            IncompleteType.DNF.equals(awayCode) ||
            IncompleteType.DNF.equals(homeCode) ||
            IncompleteType.NotPlayed.equals(awayCode) ||
            IncompleteType.NotPlayed.equals(homeCode)
        );
    }

    isIncompleteFinish() {
        return this.home.incompleteType || this.away.incompleteType;
    }
    hasNoPlayers() {
        return this.away.noPlayer && this.home.noPlayer;
    }
}
